<report-print-modal>

    <dialog id="report-print-modal" class="modal" ref="dialog" aria-labelledby="report-print-modal-title">
        <div class="modal-box max-w-2xl">
            <h3 id="report-print-modal-title" class="font-bold text-lg mb-2 text-primary">{phaseTitle()}</h3>

            <div class="text-center p-4">
                <span class="loading loading-spinner loading-lg mb-4" style="width: 50px; height: 50px"></span>
                <p class="font-semibold" role="status" aria-live="polite">{progressMessage()}</p>
            </div>
        </div>
    </dialog>

    <script>
        export default {
            state: {
                phase: 'preparing',
                done: 0,
                total: 0
            },

            phaseTitle() {
                if (!this.locale) return '';
                return this.state.phase === 'building'
                    ? this.locale.t('report_print_building')
                    : this.locale.t('report_print_preparing');
            },

            progressMessage() {
                if (!this.locale || !this.tools) return '';
                return this.locale.t('report_print_items', {
                    done: this.tools.formatNumber(Math.min(this.state.done, this.state.total)),
                    total: this.tools.formatNumber(this.state.total)
                });
            },

            show(total = 0) {
                this.state.phase = 'preparing';
                this.state.done = 0;
                this.state.total = total;
                this.update();
                const dialog = this.$('dialog');
                if (dialog && !dialog.open) dialog.showModal();
            },

            setProgress(phase, done, total) {
                this.state.phase = phase;
                this.state.done = done;
                if (total !== undefined && total !== null) this.state.total = total;
                this.update();
            },

            close() {
                const dialog = this.$('dialog');
                if (dialog && dialog.open) dialog.close();
            },

            onMounted() {
                window.reportPrintModal = this;
            }
        }
    </script>

</report-print-modal>
